import { RouteComponentProps } from "@reach/router";
import React from "react";
import MembershipPaymentForm from "../../../../../components/payment/MembershipPaymentForm";
import ActivationHeading from "../../../components/ActivationHeading";
import ActivationLayout from "../../../components/Layout";
import useRequireAuthenticated from "../../../hooks/useRequireAuthenticated";
import { navigateActivation } from "../../../utils/url";

type Props = RouteComponentProps<{ podKeyOrSerialNumber: string }>;

export default function ActivationStep3PaymentForm({
  podKeyOrSerialNumber
}: Props) {
  useRequireAuthenticated();

  /**
   * After payment has been submit to the API
   */
  const handleAfterSubscription = () => {
    navigateActivation(`${podKeyOrSerialNumber}/activation-info`);
  };

  // Membership payment form
  return (
    <ActivationLayout fullHeight>
      <MembershipPaymentForm
        onSubscription={handleAfterSubscription}
        titleComponent={ActivationHeading}
      />
    </ActivationLayout>
  );
}
